import { jsx as _jsx } from "react/jsx-runtime";
const React = require("react");
import { NewsletterForm } from "./newsletterFormBlockLayout";
const newsletterBlock = (props)=>/*#__PURE__*/ _jsx(NewsletterForm, {
        ...props
    });
export default newsletterBlock;
